import { Center } from "@chakra-ui/react";
import React from "react";

export default function NextProject(){
    return(

        <Center style={{backgroundColor: "black", width:"100%", height:"100%", position:"fixed", color:"white"}}>Coming Soon.</Center>

    );
}